import React, { Fragment } from "react";
import { useTranslation } from "react-i18next"; // I18N
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import OrganisationsSection from "../../components/OrganisationsSection/OrganisationsSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo2.png";

const PartnersPage = () => {
  const { t } = useTranslation(); // I18N
  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header-s3"} />
      <PageTitle pageTitle={t('pageTitles.partners')} pagesub={t('pageTitles.partnersSub')} />
      <OrganisationsSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default PartnersPage;
